<!-- MOLECULE: DrawerHeaderExpanded.vue -->

<script setup lang="ts">
//
// ============================================================================
// PROPS & EMITS
// ============================================================================
//

interface Props {
  appLogoExpandedMode?: string | null;
  appName?: string;
  userName?: string;
  userEmail?: string;
}

const props = withDefaults(defineProps<Props>(), {
  appLogoExpandedMode: null,
  appName: "Lab Portal",
  userName: "User Name",
  userEmail: "example@email.com",
});

//
// ============================================================================
// COMPOSABLES
// ============================================================================
//

const computedLogoSrc = useAssetPath(
  "/app-logo-white.png",
  toRef(() => props.appLogoExpandedMode),
);
</script>

<template>
  <div class="d-flex align-center ga-2 pa-4" style="min-height: 112px !important">
    <div class="d-flex flex-column opacity-100">
      <span class="d-flex align-center ga-2 text-primary text-subtitle-1 font-weight-bold mb-2">
        <!-- <v-img
        :src="computedLogoSrc"
        :width="48"
        :height="48"
        :alt="`${appName} logo`"
        class="flex-0-1"
      /> -->
        <v-icon icon="mdi-microscope" size="default" />

        {{ appName }}
      </span>

      <span class="text-primary d-flex align-center ga-2 text-body-2 font-weight-medium">
        <v-icon icon="mdi-account-outline" size="default" />
        <span>{{ userName }}</span>
      </span>

      <span class="text-primary d-flex align-center ga-2 text-caption">
        <v-icon icon="mdi-email-outline" size="small" style="width: 21px" />
        <span>{{ userEmail }}</span>
      </span>
    </div>
  </div>
</template>
